module.exports = __webpack_public_path__ + "static/media/descriptionplaceholder2.f0fd4d13.png";